var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCtaLogo = function SvgCtaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 344",
    width: 360,
    height: 344,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    fill: "#ffd801",
    d: "m184.1 23.9c-77.4 0-140.2 58.1-140.2 129.7 0 52.9 22.2 78.1 52.5 101.1l0.1 0.1v62c0 3 3.4 4.7 5.7 2.9l53.2-39.5 1.1 0.5c8.9 1.7 18.2 2.5 27.6 2.5 77.4 0 140.2-58 140.2-129.6 0-71.6-62.8-129.7-140.2-129.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    fill: "#231f20",
    d: "m331.3 152.7c0 75.1-65.9 136.1-147.2 136.1-9.9 0-19.6-0.9-28.9-2.7l-1.2-0.5-55.8 41.5c-2.5 1.8-6 0.1-6-3v-65.2l-0.2-0.1c-31.8-24.1-55.1-50.6-55.1-106.1 0-75.2 65.9-136.2 147.2-136.2 81.3 0 147.2 61 147.2 136.2zm-231.2-0.2c0-20.1 13.9-34.9 34.7-34.9 14.6 0 27.4 8.8 30.6 23h21.3c-4.9-26.1-25.1-43.3-51.9-43.3-31 0-55.5 23.1-55.5 55.2 0 32.1 24.5 55.2 55.5 55.2 26.6 0 46.6-16.9 51.8-42.5h-21.4c-3.7 13.3-16 21.9-30.4 21.9-18.9 0-34.7-14.5-34.7-34.6zm175.3 6.5c0-9.8-2.8-17.4-8.2-23-5.3-5.6-12.2-8.4-20.5-8.4-10.3 0-17.9 3.5-22.6 10.6v-40.5h-19.5v107.9h19.5v-41c0-12.6 6.5-18.8 16.7-18.8 9.1 0 15 5.5 15 15.6v44.2h19.6z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCtaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cta_logo.4cf2cec3.svg";
export { ForwardRef as ReactComponent };